// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"096485c1","911":"0ac88288"}[chunkId] + ".chunk.js";
};